import { Link } from "react-router-dom";
import { latestChapters, categories } from "@/mocks/comics";

export default function LatestUpdates() {
  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto w-full px-4 md:px-6 lg:px-10">
        <div className="mb-8 flex flex-wrap items-end justify-between gap-4">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-900">
              <i className="ri-refresh-line" aria-hidden="true" /> 更新
            </span>
            <h2 className="mt-3 font-heading text-2xl font-black text-foreground-950 md:text-3xl">最近更新</h2>
            <p className="mt-2 text-sm text-foreground-700">抢先追更，不错过任何一话</p>
          </div>
          <Link
            to="/category/all?sort=latest"
            className="flex items-center gap-1 whitespace-nowrap text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            全部更新 <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>

        <ul className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {latestChapters.map(({ comic, chapter }) => (
            <li key={`${comic.id}-${chapter.id}`}>
              <Link
                to={`/read/${comic.id}/${chapter.id}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-3 transition-all hover:border-primary-300 hover:shadow-sm"
              >
                <div className="h-20 w-14 shrink-0 overflow-hidden rounded-md">
                  <img
                    src={comic.cover}
                    alt={`${comic.title}漫画封面`}
                    title={`${comic.title} ${chapter.title} 在线阅读`}
                    className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-semibold text-foreground-950 transition-colors group-hover:text-primary-600">
                    {comic.title}
                  </h3>
                  <p className="mt-1.5 truncate text-xs text-primary-700">
                    <span className="inline-flex items-center gap-1">
                      <i className="ri-play-circle-line" aria-hidden="true" />
                      {chapter.title}
                    </span>
                  </p>
                  <p className="mt-1.5 flex items-center gap-1 text-xs text-foreground-600">
                    <i className="ri-time-line" aria-hidden="true" />
                    {chapter.date}
                  </p>
                </div>
                <span className="flex shrink-0 items-center gap-1 rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                  {categories.find((c) => c.slug === comic.categories[0])?.name || "免费"}
                </span>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}